
// Libraries
var React = require('react');
var sneakpeek = require('sneakpeek');

// Styles
require('./NotificationsIcon.scss');

class NotificationsIcon extends React.Component {

	componentDidMount() {
		sneakpeek(this.notifIcon);

		if (typeof window === "undefined") return;

		if (window.location.hash) {

			this.notifIcon.classList.add('sneakpeek--hidden');

		}
	}

	render() {
		return (
			<div className={"NotificationsIcon"} ref={(notifIcon) => { this.notifIcon = notifIcon; }}>
				<div className={"NotificationsIcon__figure"}/>
				<span className={"NotificationsIcon__total"}>25</span>
				<span className={"NotificationsIcon__transparency"}/>
			</div>
		)
	}
}

module.exports = NotificationsIcon;


// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationsIcon.js